export default class BackToTop {

	constructor() {
		this.button = document.querySelector('.footer__back-to-top');

		this.onClick  = this.onClick.bind(this);
		this.onScroll = this.onScroll.bind(this);

		this.button.addEventListener('click', this.onClick);
		window.addEventListener('scroll', this.onScroll);
		window.addEventListener('touchmove', this.onScroll);
	}

	onClick(e) {
		vb.scroll.top(0, 800);
	}

	onScroll(e) {
		if (window.pageYOffset > document.body.offsetHeight / 3) {
			this.button.classList.add('footer__back-to-top--visible');
		} else {
			this.button.classList.remove('footer__back-to-top--visible');
		}
	}

}
